import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoFooterDialogFn = /* @__PURE__ */ createRecipe('logo-footer-dialog', {}, [])

const logoFooterDialogVariantMap = {}

const logoFooterDialogVariantKeys = Object.keys(logoFooterDialogVariantMap)

export const logoFooterDialog = /* @__PURE__ */ Object.assign(memo(logoFooterDialogFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoFooterDialog',
  __getCompoundVariantCss__: logoFooterDialogFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoFooterDialogVariantKeys,
  variantMap: logoFooterDialogVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoFooterDialogVariantKeys)
  },
  getVariantProps: logoFooterDialogFn.getVariantProps,
})